import { ShipmentType } from '../enums/shipment-type';
import { ShipmentWithNotifications } from './shipment-delivery-schedule';

export class ContainerWithNotifications extends ShipmentWithNotifications {

    constructor() {
        super(ShipmentType.Container);
    }
}
